/* Arredonda a porcentagem mostrada no botao ADICIONAR.
   A escada usa percentuais com decimais (22.87 / 26.55) para bater centavo
   a centavo com o desconto automatico da colecao. Mostrar "22.87% off" na
   tela parece defeito, entao aqui so o RÓTULO é arredondado para baixo.
   O preco continua vindo do vf.js, nada e recalculado. */
(function(){
  var alvo=null, ligado=false;
  function acha(){
    return document.querySelector('[data-add]');
  }
  /* Tira o travessao do texto do botao. O vf.js monta "ADICIONAR — R$ 129,00";
     travessao nao entra em nada que o cliente le, entao ele sai aqui, no proprio
     no de texto, sem reescrever o vf.js. O valor continua vindo de la. */
  function semTravessao(el){
    for(var i=0;i<el.childNodes.length;i++){
      var n=el.childNodes[i];
      if(n.nodeType===3){
        if(n.nodeValue.indexOf('—')>=0){
          var v=n.nodeValue.replace(/\s*—\s*/g, ' ');
          if(v!==n.nodeValue){ ligado=true; n.nodeValue=v; ligado=false; }
        }
      } else if(n.nodeType===1){
        semTravessao(n);
      }
    }
  }
  function limpa(){
    var b=acha(); if(!b) return;
    semTravessao(b);
    var s=b.querySelector('small'); if(!s) return;
    var t=s.textContent;
    var novo=t.replace(/(\d+)[.,](\d+)%/, function(m,a){ return a+'%'; });
    if(novo!==t){ ligado=true; s.textContent=novo; ligado=false; }
  }
  function inicia(){
    alvo=acha(); if(!alvo){ return setTimeout(inicia, 400); }
    limpa();
    var mo=new MutationObserver(function(){ if(!ligado) limpa(); });
    mo.observe(alvo, {childList:true, subtree:true, characterData:true});
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', inicia); }
  else { inicia(); }
})();

/* v33: a pagina ja sai pronta do servidor. A camada vf-mobile2.js nao e mais
   carregada aqui. O arquivo continua no tema, sem uso, caso precise voltar. */
